<template>
    <div class="home-nav">
        <div v-el:scroll class="home-nav-scroll">
            <ul class="home-nav-list">
                <li v-for="(index,item) in menuList">
                    <a :class="{'active' : cateid == item.cateid}" :href="item.href" v-touch:tap="onNavTap(index,item.cateid)">{{item.cateName}}</a>
                </li>
            </ul>
        </div>
        <a class="down" @click="onShowMenuClick"></a>
    </div>
</template>
<style lang="less">
    @import "NavigationBar.less";
</style>
<script>
    var iScroll = require('iscroll'),
        vTouch = require('vue-touch'),
        leStatic = require('../../../libs/leStatic');
    module.exports = {
        props: ['menuList','cateid','isShowMenu'],
        ready : function(){
            this.scroll = new iScroll(this.$els.scroll,{
                scrollX : true,
                snap: true
            });
        },
        watch:{
            "cateid": function(){
                var domActive = document.querySelector('.home-nav-scroll .active');
                if(domActive){
                    this.scroll.scrollToElement(domActive, null, null, true);
                }
            }
        },
        methods: {
            onNavTap: function (index,cateid) {
               leStatic('MONITOR-TAB');
               this.$dispatch('change',cateid);
            },
            onShowMenuClick: function () {
                this.isShowMenu = true
            }
        }
    }
</script>



/** WEBPACK FOOTER **
 ** NavigationBar.vue?e8f8053e
 **/